// ============================================================================
// RUSSIAN TRANSLATIONS - CHAPTER 8: ПОМОЩЬ ВСЕВЫШНЕГО (БОНУС)
// ============================================================================
// Уровень 92 (1 бонусный уровень, 3 вопроса)

export const chapter8Translations = {
  name: "Помощь Всевышнего",
  description: "Живущий под кровом Всевышнего под сенью Всемогущего покоится",
  
  spiritualWisdom: {
    principle: "Вы достигли вершины горы, и знание приобретено",
    scripture: "Живущий под кровом Всевышнего под сенью Всемогущего покоится (Псалом 90:1)",
    application: "Непоколебимая вера требует жизненного опыта, милосердия и истинной любви Иисуса. Испытания проверят ваше сердце, истинный избранный путь."
  },
  
  levels: {
    92: {
      name: "Кров Всевышнего",
      challenge: "Вы на вершине горы... Но непоколебимая вера начинается сейчас...",
      easy: {
        question: "Кто такой Иисус для вас лично?",
        options: [
          "Простой пророк",
          "Мой личный Господь и Спаситель",
          "Легенда",
          "Философ"
        ],
        hint: "Он Тот, Кто отдает Свою жизнь, чтобы спасти нас",
        funFact: "✝️ Иисус - это Бог! Он не просто историческая личность - Он жив и желает личных отношений с каждым из нас!"
      },
      medium: {
        question: "Почему пост, как у Даниила, позволяет нам лучше слышать Бога?",
        options: [
          "Чтобы похудеть",
          "Чтобы лишить себя того, что мы любим, и иметь преображенное сердце",
          "Чтобы произвести впечатление на других",
          "Чтобы быть сильнее"
        ],
        hint: "Лишите себя того, что вы любите больше всего, в тишине и мудрости",
        funFact: "🙏 Духовный пост готовит наше сердце к глубоким преображениям - часто болезненным - которые приближают нас к Богу!"
      },
      hard: {
        question: "Каков истинный ответ сердца на все это приобретенное знание?",
        options: [
          "Теперь я совершенен",
          "Я отдаю Тебе свое сердце, Иисус, и желаю креститься",
          "Я знаю лучше других",
          "Мне больше не нужна помощь"
        ],
        hint: "Истинная вера ведет к полной отдаче и посвящению Иисусу",
        funFact: "🌟✨ Вы достигли вершины горы, и знание приобретено ✨\n\n💖 Непоколебимая вера требует жизненного опыта, милосердия и истинной любви Иисуса 💖\n\n🔥 Различные испытания жизни проверят ваш путь, истинную дорогу, которую мы выбираем, наше сердце 🔥\n\n😔 Мы остаемся несовершенными, наши желания многочисленны, и любовь к наживе или к нашему личному комфорту слишком часто становится нашим эгоистичным приоритетом 😔\n\n🙏 Просите у Бога мудрости, Его любви, Его силы и смиренно признавайте свои слабости, ибо мы не можем скрыть от Него ничего... Ничего 🙏\n\n🥖 Поститесь, как Даниил: лишите себя на время того, что вы любите больше всего, в тишине и мудрости 🥖\n\n💫 Это позволит вам лучше слышать Бога, иметь готовность сердца к глубоким преображениям 💫\n\n🌙 Тогда сны и видения станут яснее, как у Иосифа 🌙\n\n⚠️ Остерегайтесь гордыни: не поддавайтесь на 'я всегда прав' или 'я знаю лучше' ⚠️\n\n🎁 Ибо откровение Бога - это необыкновенная благодать 🎁\n\n💝 Иметь веру - значит войти в отношения и свободный путь сердца 💝\n\n🦸‍♂️ Это сделает вас могущественными героями, способными на невозможное 🦸‍♂️\n\n✝️ На вершине знания искреннее сердце говорит: 'Я отдаю Тебе свое сердце, Иисус, и желаю креститься' ✝️\n\n🏔️ Вы достигли вершины горы, держитесь крепче, проявите настойчивость! 🏔️\n\n⬇️ Нужно спуститься и нести это драгоценное сокровище: надежду на вечную жизнь ⬇️\n\n🏆✨ БРАВО! МЫ ГОРДИМСЯ ТОБОЙ ✨🏆\n🌟 МУЖЕСТВО ДОБЛЕСТНЫЙ МИРОТВОРЕЦ 🌟\n🕊️✨ ДА БЛАГОСЛОВИТ ТЕБЯ БОГ ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
